import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/login';
import AdminDashboard from './component/admin-dashboard';
import BackendDashboard from './component/backend-dashboard';
import Sidebar from './component/sidebar';
import EmployeesTable from './component/employees-table';
import EmployeeDetails from './component/employee-details';
import EmployeeDocuments from './component/employee-documents';
import UsersTable from './component/users-table';
import UserForm from './component/user-form';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');

    if (token) {
      if (userData) {
        try {
          const parsedUser = JSON.parse(userData);
          if (parsedUser && typeof parsedUser === 'object') {
            setUser(parsedUser);
          } else {
            setUser({ role: 'admin', name: 'Admin', email: '' });
          }
        } catch (e) {
          localStorage.removeItem('user');
          setUser({ role: 'admin', name: 'Admin', email: '' });
        }
      } else {
        setUser({ role: 'admin', name: 'Admin', email: '' });
      }
    } else {
      setUser(null);
    }

    setLoading(false);
  }, []);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  const handleLogout = () => {
    localStorage.clear();
    setUser(null);
    window.location.href = '/login';
  };

  if (!user) {
    return (
      <Router>
        <Routes>
          <Route path="/user" element={<Login setUser={setUser} />} />
          <Route path="/login" element={<Login setUser={setUser} />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
    );
  }

  return (
    <Router>
      <div className="app-container">
        <Sidebar user={user} onLogout={handleLogout} />
        <div className="main-content">
          <Routes>
            <Route path="/dashboard" element={<AdminDashboard user={user} />} />
            <Route path="/employees" element={<EmployeesTable />} />
            <Route path="/employees/:id/details" element={<EmployeeDetails />} />
            <Route path="/employees/:id/documents" element={<EmployeeDocuments />} />
            <Route path="/documents" element={<BackendDashboard user={user} />} />
            <Route path="/users" element={<UsersTable />} />
            <Route path="/users/create" element={<UserForm />} />
            <Route path="/users/:id/edit" element={<UserForm />} />
            <Route path="*" element={<Navigate to="/dashboard" />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
